var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconComfortEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7 10.9499C17.7 6.7499 21.05 3.3999 25.25 3.3999C29.45 3.3999 32.8 6.7499 32.8 10.9499V25.9999C35.3 28.2999 36.75 31.4499 36.75 35.1999C36.75 41.8999 31.5 47.0999 25.25 47.0999C19 47.0999 13.75 41.6499 13.75 35.1999C13.75 28.7499 15.4 28.2999 17.7 25.9999V10.9499Z",
    stroke: "#62797E",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2 13.2C23.9 13.2 22.6 14.25 22.6 15.8V27.8C19.75 28.85 17.65 31.6999 17.65 35.3499C17.65 38.9999 21.05 43.15 25.2 43.15C29.35 43.15 32.75 39.4999 32.75 35.3499C32.75 31.1999 30.65 29.1 27.8 27.8V15.8C27.55 14.5 26.5 13.2 25.2 13.2Z",
    fill: "#069BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComfortEmptyState);
export default __webpack_public_path__ + "static/media/icon_comfort_empty_state.0640093e53c8453d3b14026082fb6ba0.svg";
export { ForwardRef as ReactComponent };